import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';

export default function NoPage() {
  return (
    <>
    <MainLayout>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>404 Response Error</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">404 Response Error</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>
    </div>

    <div className='inner_page_content'> 
      <div className='container mb-5'>

      <div className='row'>
        <div className='col-12 mt-4 mb-5'>

     <h4>This page isn't here, but you're not lost.</h4>
     <p>You're in the right place to get your venture growing. Start with the tools below or head to our home page to get started.</p>

    <Link to='/' className='btn btn-primary'>Back to Home Page</Link>


        </div>
        </div>

      </div>
    </div>

    </MainLayout>
    </>
  )
}
